export default {
      id: "btn_close-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#btn_close",
      toString: function () {
        return this.url;
      }
    }